import { render, staticRenderFns } from "./ServerBlock.vue?vue&type=template&id=3ae49000&lang=pug"
import script from "./ServerBlock.vue?vue&type=script&lang=js"
export * from "./ServerBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports